import * as SwitchPrimitives from '@radix-ui/react-switch';
import { clsx } from 'clsx';
import { Moon, Sun } from 'lucide-react';
import * as React from 'react';

import { useTheme } from './theme.provider';
import styles from './theme-switcher.module.scss';

type ThemeSwitcherProps = Omit<
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>,
  'checked' | 'onCheckedChange'
> & {
  onThemeChange?: (theme: 'dark' | 'light') => void;
};

const ThemeSwitcher = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  ThemeSwitcherProps
>(({ className, onThemeChange, ...props }, ref) => {
  const { theme, setTheme } = useTheme();

  return (
    <SwitchPrimitives.Root
      ref={ref}
      className={clsx(styles.root, className)}
      checked={theme === 'dark'}
      onCheckedChange={(checked) => {
        setTheme(checked ? 'dark' : 'light');
        onThemeChange?.(checked ? 'dark' : 'light');
      }}
      {...props}
    >
      <SwitchPrimitives.Thumb className={styles.thumb}>
        {theme === 'dark' ? (
          <Moon className={styles.icon} />
        ) : (
          <Sun className={styles.icon} />
        )}
      </SwitchPrimitives.Thumb>
    </SwitchPrimitives.Root>
  );
});

ThemeSwitcher.displayName = 'ThemeSwitcher';

export { ThemeSwitcher };
export type { ThemeSwitcherProps };
